// axios
import axios from "axios";
import Auth from "@aws-amplify/auth";

const baseURL = process.env.VUE_APP_API_URL;

const Axios = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  // You can add your headers here
});

// For Cypress
let lastAccessToken;

Axios.interceptors.request.use(function (config) {
  if (!navigator.onLine) {
    console.log(
      "Você está offline. Por favor, verifique sua conexão com a internet."
    );
  }

  return Auth.currentSession()
    .then((session) => {
      // User is logged in.

      // Set auth header on all requests
      let accessToken = session.idToken.jwtToken;

      config["headers"]["Authorization"] = accessToken;
      lastAccessToken = accessToken;

      return Promise.resolve(config);
    })
    .catch((err) => {
      // console.log("Error Axios Interceptor: ", err);
      if (lastAccessToken) {
        config["headers"]["Authorization"] = lastAccessToken;
      }
      return Promise.resolve(config);
    });
});

// Tratar erros de rede
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === "Network Error") {
      console.log(
        "Erro de rede: não foi possível conectar ao servidor. Verifique sua conexão com a internet."
      );
    } else if (axios.isCancel(error)) {
      console.log("Requisição cancelada:", error.message);
    } else {
      console.log(`Erro ao fazer a requisição: ${error.message}`);
    }
    // return Promise.reject(error);
  }
);

/*Axios.get("/participants/exists/12345678901")
  .then((response) => {
    console.log("Calling API to start DB - Status OK");
  })
  .catch((error) => {
    console.log("Calling API to start DB - Status ERROR: ", error);
  });*/

export default Axios;
